module.exports = __webpack_public_path__ + "img/wesley.44ba6c9.png";